import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        formContainer: {
            margin: '0 auto',
            maxWidth: '90vw',
            width: 600,
        },
        alignRight: {
            display: 'flex',
            justifyContent: 'flex-end',
            width: '100%',
        },
        rootMobile: {
            width: '100%',
            background: '#fcfcfd',
            padding: `${theme.spacing(4)}px`,
        },
        buttonContainer: {
            padding: '16px 24px',
            background: '#fff',
            border: '1px solid #dadce0',
            borderTop: 'none',
            borderBottom: 'none',
            boxSizing: 'border-box',
        },
    }),
);
